module.exports = __webpack_public_path__ + "img/xqimg1.478a4c27.png";